// A dropdown menu for selecting athletes.
// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import SearchableDropDown from './SearchableDropDown';
import type { Suggestion } from './dropdown/constants';

export type AthleteSelectionProps = {
    data: any,
    selectedId: number,
    onSelect: () => void,
    isFocused: boolean
};

export class AthleteSelectionStandalone extends PureComponent<
    AthleteSelectionProps
> {
    static defaultProps = {
        selectedId: 0,
        onSelect: () => {},
        isFocused: true
    };

    getTransformedDataSet = () => {
        const { data: athletes, selectedId } = this.props;

        let selected = null;

        let data: Array<Suggestion> = [];

        // Massage the data to adhere to the Suggestion API.
        for (let i = 0; i < athletes.length; i++) {
            const { id, fullName, image_profile } = athletes[i];

            if (id === selectedId) {
                selected = i;
            }

            data.push({
                id,
                text: fullName,
                image: image_profile
            });
        }

        return {
            data,
            selected
        };
    };

    render() {
        const { data, selected } = this.getTransformedDataSet();
        return (
            <div className="fixed-width-dropdown">
                <SearchableDropDown
                    data={data}
                    selected={data[selected]}
                    onSelect={this.props.onSelect}
                    isOpen={this.props.isFocused && selected === null}
                    key={`sdd_${data.length}`}
                    placeholder="Search Athletes"
                />
            </div>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        data: state.library.athletesTree
    };
};

export default connect(mapStateToProps)(AthleteSelectionStandalone);
